const t = {
  name: "Academy",
  dimensions: { width: 21, height: 21 },
  content: `
    <g fill="none" stroke="currentColor" clip-path="url(#clip0_3543_93)">
        <path d="M1.20508 7.5L10.2051 1.5L19.2051 7.5L10.2051 13.5L1.20508 7.5Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/>
        <path d="M19.2051 7.5V13.5" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16.2051 9.5V13.5C16.2051 16.81 13.5151 19.5 10.2051 19.5C6.89508 19.5 4.20508 16.81 4.20508 13.5V9.5" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
        <clipPath id="clip0_3543_93">
            <rect width="20" height="20" fill="white" transform="translate(0.205078 0.5)"/>
        </clipPath>
    </defs>
  `
};
export {
  t as Academy
};
